import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa17b7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "class-card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "fields" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Course:", -1))
const _hoisted_7 = { class: "field-value" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Start:", -1))
const _hoisted_10 = { class: "field-value" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Status:", -1))
const _hoisted_13 = { class: "field-value" }
const _hoisted_14 = { class: "flex flex-col ml-6" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Class:", -1))
const _hoisted_17 = { class: "field-value" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "End:", -1))
const _hoisted_20 = { class: "field-value" }
const _hoisted_21 = { class: "class-actions" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Change Class Information ")

import { computed, PropType } from 'vue';
import { Class } from '../../../../models/Class';
import { formatDate_DD_MMM_YYYY } from '../../../../utils/utils';
import ButtonComponent from '@/components/ButtonComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassInformationWidget',
  props: {
  courseClass: {
    type: Object as PropType<Class>,
    required: true
  },
  courseName: {
    type: String
  }
},
  emits: ['edit-class'],
  setup(__props, { emit: emits }) {

const props = __props



const classStatus = computed(() => {
  let status = 'Archived';
  if (props.courseClass.isActive) {
    status = 'Active';
  }
  return status;
});



const handleEditClicked = () => {
  emits('edit-class', props.courseClass);
};

return (_ctx: any,_cache: any) => {
  return (props.courseClass.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", null, "Class " + _toDisplayString(props.courseClass?.name) + " Information", 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, _toDisplayString(props.courseName), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatDate_DD_MMM_YYYY)(new Date(props.courseClass.startDate))), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(classStatus)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, _toDisplayString(props.courseClass.name), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(formatDate_DD_MMM_YYYY)(new Date(props.courseClass.endDate))), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(ButtonComponent, {
            class: "whitespace-nowrap",
            "color-type": "tertiary",
            size: "medium",
            onClick: handleEditClicked
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})